import { SYSAudit } from "../../ovlsyscomponents/sysaudit01/features/allactions"
import { SYSEPT } from "../../ovlsyscomponents/sysept01/features/allactions"
import { SYSLandingPage01 } from "../../ovlsyscomponents/syslandingpage01/features/allactions"

import { SYSLogin } from "../../ovlsyscomponents/syslogin01/features/allactions"
import { SYSTOTP } from "../../ovlsyscomponents/systotp01/features/allactions"
import { SYSTranslation } from "../../ovlsyscomponents/systranslation01/features/allactions"
import { SYSUserAdministration } from "../../ovlsyscomponents/sysuseradministration01/features/allactions"
import { SYSUserSettingsPassword } from "../../ovlsyscomponents/sysusersettings01/password/features/allactions"

export let features = {
  SYSAudit,
  SYSEPT,
  SYSLandingPage01,
  SYSLogin,
  SYSTOTP,
  SYSTranslation,
  SYSUserSettingsPassword,
  SYSUserAdministration,
}
